import { BuildVersion, IEnvironment } from './environment.interface';
import buildVersion from '@env/buildVersion';

const apiUrl = 'https://api-sdoh.portalstg2.mynexuscare.com';
const hhApiUrl = 'https://api-homehealth.portalstg2.mynexuscare.com';

export const environment: IEnvironment = {
  apiUrl,
  hhApiUrl,
  modules: [],
  production: false,
  routes: [],
  version: buildVersion as BuildVersion,
};
